module.exports = __webpack_public_path__ + "static/Spartan-Logo-92c6b2790209d2041c8abeebc442c2b2.jpg";